export default { adults: 2, children: 0 };
